@if (isVisible) {
  <div class="chatbot-container">
    <div
      class="chat-panel-wrapper"
      [attr.inert]="isOpen ? null : ''"
    >
      <button
        type="button"
        class="resize-handle"
        (pointerdown)="onResizeStart($event)"
        (pointermove)="onResizeMove($event)"
        (pointerup)="onPointerEnd($event)"
        (pointercancel)="onPointerEnd($event)"
        (keydown)="onResizeKeydown($event)"
        [attr.aria-label]="resizeLabel"
        [attr.title]="resizeHint"
      ></button>
      @if (showPanel) {
        <app-chat-panel (closeRequested)="toggleChat()"></app-chat-panel>
      }
    </div>
  </div>

  <div
    class="chat-tab"
    [style.top]="tabTop()"
    [attr.inert]="isOpen ? '' : null"
    [attr.aria-hidden]="isOpen"
  >
    <button
      type="button"
      class="chat-fab"
      (click)="onTabClick($event)"
      [attr.aria-label]="tabLabel"
      [attr.aria-expanded]="isOpen"
      (pointerdown)="onTabDragStart($event)"
      (pointermove)="onTabDragMove($event)"
      (pointerup)="onPointerEnd($event)"
      (pointercancel)="onPointerEnd($event)"
      [attr.title]="tabHint"
    >
      <mat-icon aria-hidden="true">smart_toy</mat-icon>
    </button>
  </div>
}
